// GlassBar — floating nav bars + headers. Stronger surface, sits above content.
import React from 'react';
import GlassSurface, { GlassSurfaceProps } from './GlassSurface';
import { glassTokens } from './tokens';

export default function GlassBar({
  radius = glassTokens.radius.xl,
  ...rest
}: GlassSurfaceProps) {
  return <GlassSurface variant="bar" radius={radius} {...rest} />;
}
